export const tableButtonFontSize = { fontSize: '18px' };
export const tableButtonSize = 'small';
